import { getUserFromStorage } from "../../util/localStorage.util";

const storageInfo = getUserFromStorage();

export const requestHeader = {
  headers: {
    Authorization: `Bearer ${
      storageInfo ? JSON.parse(storageInfo).data.token : ""
    }`, //the token is a variable which holds the token
  },
};
